import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold mb-4">哈哈漫画网</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              专注韩国漫画在线阅读，海量优质漫画资源免费看。每日更新，让您追更不等待。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">漫画分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li>
                <span className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  contact@hahamanhua.com
                </span>
              </li>
              <li>
                <span className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  韩国首尔市江南区
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2025-2026 哈哈漫画网 hahamanhua.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400">友情链接：</span>
              <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">漫画导航</a>
              <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">动漫之家</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}